import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Clear from "/assets/Weather=Sunshine.png";
import Clouds from "/assets/Weather=Cloudy.png";
import Rain from "/assets/Weather=Rainny.png";
import lampIcon from "/assets/lamp.png";
import hail from "/assets/hail.png";
import windy from "/assets/windy.png";
import rain from "/assets/rain.png";
import pm_5 from "/5.png?url";
import pm_89 from "/89.png?url";
import pm_130 from "/130.png?url";
import pm_198 from "/198.png?url";
import pm_260 from "/260.png?url";
import pm_499 from "/499.png?url";
import Detail from "./Detail";
import ShowData from "./ShowData";
import "./styles/Weather.css";
import { IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const Weather = () => {
  const [polesData, setPolesData] = useState([]);
  const [currentPoleIndex, setCurrentPoleIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [animationClass, setAnimationClass] = useState("");
  const [showData, setShowData] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [selectedPole, setSelectedPole] = useState(null);
  const [confirmedPole, setConfirmedPole] = useState(null);
  const [isCycling, setIsCycling] = useState(true);
  const [activeDetail, setActiveDetail] = useState(null);
  const location = useLocation();
  const intervalRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/api/weather/${
            sessionStorage.getItem("selectedBranch") || "defaultBranchName"
          }`
        );
        setPolesData(response.data);
        setLoading(false);
      } catch (error) {
        console.error(`Error fetching data: ${error.message}`);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const startCycling = () => {
    intervalRef.current = setInterval(() => {
      setAnimationClass("text-slide-left-exit");
      setTimeout(() => {
        setCurrentPoleIndex((prevIndex) => (prevIndex + 1) % polesData.length);
        setAnimationClass("text-slide-left-enter");
      }, 500);
    }, 8000);
  };

  const stopCycling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    if (isCycling) {
      startCycling();
      return () => stopCycling();
    }
  }, [polesData.length, isCycling]);

  const getPMImage = (pmValue) => {
    if (pmValue <= 5) return pm_5;
    if (pmValue <= 89) return pm_89;
    if (pmValue <= 130) return pm_130;
    if (pmValue <= 198) return pm_198;
    if (pmValue <= 260) return pm_260;
    return pm_499;
  };

  const getPMColor = (pmValue) => {
    if (pmValue <= 5) return "#38500C";
    if (pmValue <= 89) return "#67520B";
    if (pmValue <= 130) return "#673614";
    if (pmValue <= 198) return "#5A1B1C";
    if (pmValue <= 260) return "#4C2065";
    return "#451827";
  };

  const determineWeatherCondition = (sensor) => {
    // ตรวจสอบว่า sensor มีค่าและไม่เป็น null
    if (!sensor) return Clouds;

    if (sensor.windSpeed > 25) return Clouds;
    if (sensor.rain > 0.5) return Rain;
    if (sensor.temperature > 25 && sensor.humidity < 50) return Clear;
    return Clouds;
  };

  const toggleShowData = () => setShowData(!showData);
  const toggleDropdownVisibility = () =>
    setIsDropdownVisible(!isDropdownVisible);
  const handlePoleSelection = (pole) => {
    setSelectedPole(pole);
    setIsDropdownVisible(false);
  };
  const handleConfirmSelection = () => {
    setConfirmedPole(selectedPole);
    setIsCycling(false);
    setShowData(false);
  };
  const handleDetailClick = () =>
    setActiveDetail(confirmedPole || polesData[currentPoleIndex]);
  const handleCloseDetail = () => setActiveDetail(null);

  const handlePrevClick = () => {
    stopCycling();
    setAnimationClass("text-slide-right-exit");
    setTimeout(() => {
      setCurrentPoleIndex(
        (prevIndex) => (prevIndex - 1 + polesData.length) % polesData.length
      );
      setAnimationClass("text-slide-right-enter");
    }, 500);
    startCycling();
  };

  const handleNextClick = () => {
    stopCycling();
    setAnimationClass("text-slide-left-exit");
    setTimeout(() => {
      setCurrentPoleIndex((prevIndex) => (prevIndex + 1) % polesData.length);
      setAnimationClass("text-slide-left-enter");
    }, 500);
    startCycling();
  };

  if (loading)
    return (
      <div className="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    );
  if (polesData.length === 0) return <p>No data available.</p>;

  const currentPole = confirmedPole || polesData[currentPoleIndex];
  const sensor = currentPole?.sensor || {}; // ใช้ค่าเริ่มต้นเป็นอ็อบเจ็กต์ว่างเปล่า

  return (
    <>
      {showData && (
        <ShowData
          polesData={polesData}
          selectedPole={selectedPole}
          isDropdownVisible={isDropdownVisible}
          toggleDropdownVisibility={toggleDropdownVisibility}
          handlePoleSelection={handlePoleSelection}
          handleConfirmSelection={handleConfirmSelection}
          setShowData={setShowData}
        />
      )}

      <div className="z9999">
        {" "}
        <div className={animationClass}>
          <img
            src={determineWeatherCondition(sensor)}
            alt="Weather Icon"
            className="weather-icon"
          />
        </div>
      </div>
      <div className="weather-api-component">
        <IconButton
          className="nav-button nav-button-left"
          onClick={handlePrevClick}
          aria-label="previous"
        >
          <ChevronLeftIcon />
        </IconButton>
        <IconButton
          className="nav-button nav-button-right"
          onClick={handleNextClick}
          aria-label="next"
        >
          <ChevronRightIcon />
        </IconButton>
        {location.pathname === "/dashboard" && (
          <div
            className="kabab"
            onClick={toggleShowData}
            style={{ cursor: "pointer" }}
          >
            &#8942;
          </div>
        )}

        {location.pathname === "/weather" && (
          <img
            src={lampIcon}
            alt="ไฟ"
            className="Lamp"
            onClick={handleDetailClick}
            style={{ cursor: "pointer" }}
          />
        )}

        <div className="weather-data-container">
          <div className="weather-content">
            <div className="weather-ltitle">
              <div className="centerHead">
                {" "}
                <h6 className={animationClass}>
                  {sensor.temperature ?? "N/A"}°C
                </h6>
              </div>

              <div className={`max_min ${animationClass}`}>
                <label>{currentPole.name ?? "N/A"}</label>
                <label> | {currentPole.isMaster ? "เสาหลัก" : "เสารอง"}</label>
                <label> {currentPole.code ?? "N/A"}</label>
              </div>
            </div>
            <div className={`column-container ${animationClass}`}>
              <img src={rain} alt="rain" className="title" />
              <img src={windy} alt="windy" className="title" />
              <img src={hail} alt="hail" className="title" />
              <label className={animationClass}>ปริมาณน้ำฝน</label>
              <label className={animationClass}>ความกดอากาศ</label>
              <label className={animationClass}>PM 1 µg./m3</label>
              <strong className={animationClass}>{sensor.rain ?? "N/A"}</strong>
              <strong className={animationClass}>
                {sensor.pressure ?? "N/A"} hPa
              </strong>
              <strong className={animationClass}>{sensor.pm1 ?? "N/A"}</strong>
              <label className={animationClass}>ความชื้น</label>
              <label className={animationClass}>ความเร็วลม</label>
              <label className={animationClass}>PM 2.5 µg./m3</label>
              <strong className={animationClass}>
                {sensor.humidity ?? "N/A"}
              </strong>
              <strong className={animationClass}>
                {sensor.windSpeed ?? "N/A"} km/h
              </strong>
              <strong className={animationClass}>
                {sensor.pm2_5 ?? "N/A"}
              </strong>
              <label></label>
              <label>ทิศทางลม</label>
              <label>PM 10 µg./m3</label>
              <strong></strong>
              <strong className={animationClass}>
                {sensor.windDirection ?? "N/A"}
              </strong>
              <strong className={animationClass}>{sensor.pm10 ?? "N/A"}</strong>
              <div className="pm2_5img">
                <img
                  src={getPMImage(sensor.pm2_5 ?? 0)}
                  alt={`PM 2.5: ${sensor.pm2_5 ?? "N/A"}`}
                  className="pm2_5"
                />
                <strong style={{ color: getPMColor(sensor.pm2_5 ?? 0) }}>
                  {Math.floor(sensor.pm2_5 ?? 0)}
                </strong>
              </div>
            </div>
          </div>
        </div>
        {activeDetail && (
          <Detail
            title="รายละเอียดเสา"
            weatherData={activeDetail}
            onClose={handleCloseDetail}
            code={activeDetail.code}
            name={activeDetail.name}
            location={activeDetail.location}
            lat={activeDetail.latitude}
            lng={activeDetail.longitude}
            sensors={activeDetail.sensor}
            isMaster={activeDetail.isMaster}
            screenCode={activeDetail.screenId}
            screenModel={activeDetail.screenModel}
            installDate={activeDetail.screenInstallationDate}
            active={activeDetail.active}
            hasScreen={activeDetail.hasScreen}
          />
        )}
      </div>
    </>
  );
};

export default Weather;
